export default __webpack_public_path__ + "static/media/pageNotFound.01ba9d50.jpg";